import { type MoveEvent, QUEEN, TYPE_MASK, TRAITOR_EVERY, inTraitorDanger, pieceColor, swapIn } from '@chessbut/engine';
import type { Decoration, VariantUi } from './ui.ts';

const TRAITOR = '/art/traitor.svg';
const betrayed = (e: MoveEvent) => e.t === 'fx' && e.kind === 'betray';

export const traitorUi: VariantUi = {
  heroImage: TRAITOR,
  peek: [{}, { image: '/art/bK.svg', threat: true }, {}, {}, { image: '/art/wQ.svg' }, {}, {}, {}, { image: '/art/wK.svg' }],

  decorations(pos) {
    if (swapIn(pos) > 2) return [];
    const out: Decoration[] = [];
    for (let sq = 0; sq < 64; sq++) {
      const p = pos.board[sq];
      if ((p & TYPE_MASK) === QUEEN && pieceColor(p) !== -1) out.push({ kind: 'mark', sq, tone: 'doomed' });
    }
    return out;
  },

  twist(pos, you) {
    const n = swapIn(pos);
    if (inTraitorDanger(pos) && (you === null || you === pos.turn)) {
      return { text: 'Get your king away from your queen: she switches sides after this move!', alert: true };
    }
    return {
      text: n === 1 ? 'The queens switch sides after this move!' : `The queens switch sides in ${n} moves`,
      pips: { on: TRAITOR_EVERY - n, total: TRAITOR_EVERY, title: 'Moves until the queens switch sides' },
      alert: n <= 2,
    };
  },

  threatText: (you) => (you ? 'Your queen turns on you next move. Get your king clear!' : 'A queen is about to turn on her king!'),

  eventSound(e) {
    return betrayed(e) ? 'betray' : null;
  },

  moveBadge(rec) {
    return rec.events.some(betrayed) ? { icon: TRAITOR, title: 'The queens switched sides' } : null;
  },
};
